import { Flex, Spinner } from '@chakra-ui/react'

export const Loading = () => {
  return (
    <Flex w="100%" justifyContent="center">
      <Spinner color="white" />
    </Flex>
  )
}
